import { take, put } from "redux-saga/effects";
import { ACTIVATE_MASK_ITEM, SET_ACTIVE_MENU_PATH, SET_MENU_CACHE } from "../../actions/configurationActions";
import { CONTENT_LOADING, OPEN_SIDE_MENU } from "../../actions/sideMenuActions";

function* toggleSideMenu(isOpen: boolean) {
    yield put({
        type: OPEN_SIDE_MENU,
        sideMenuOpen: isOpen,
    });
}

export function* sideMenuActivateItemSaga(): any {
    while (true) {
        const action: any = yield take([ACTIVATE_MASK_ITEM, SET_ACTIVE_MENU_PATH]);
        // Remote-control reloads flag the path reset so it doesn't pop the menu open.
        if (action.suppressMenuOpen) {
            continue;
        }
        yield toggleSideMenu(true);
    }
}

export function* sideMenuSetItemsSaga(): any {
    while (yield take(SET_MENU_CACHE)) {
        yield put({
            type: CONTENT_LOADING,
            contentLoading: false,
        });
    }
}
